// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17pbO","toggle":"styles_toggle__3WObZ","preview":"styles_preview__1o-SK"};